export default __webpack_public_path__ + "images/models/97dac9c8bcc3c6524d2e130e13eaa30c.usdz";